import "./StartGrowing.css";

export default function StartGrowing() {
  return (
      <section class="cta-section">
          <div class="cta-content">
              <h1>Start Growing with the Right Data</h1>
              <p>
                  Access verified leads and powerful survey insights that help your business
                  reach the right customers and make smarter decisions.
              </p>

              <div class="cta-buttons">
                  <a href="request" class="btn primary">Request Data</a>
                  <a href="request" class="btn outline">Launch Survey</a>
              </div>
          </div>
      </section>
  );
}